import { AfterViewInit, Directive, ElementRef, Input, NgModule, OnDestroy } from '@angular/core';
import type { Config } from 'datatables.net';

declare const $: any;

@Directive({
  selector: '[datatable]',
  standalone: true,
})
export class DatatableCompatDirective implements AfterViewInit, OnDestroy {
  @Input() dtOptions: Config = {};

  dtInstance: Promise<any>;
  private resolveDtInstance!: (value: any) => void;
  private tableInstance: any;

  constructor(private readonly elementRef: ElementRef<HTMLTableElement>) {
    this.dtInstance = new Promise((resolve) => {
      this.resolveDtInstance = resolve;
    });
  }

  ngAfterViewInit(): void {
    queueMicrotask(() => this.initTable());
  }

  ngOnDestroy(): void {
    try {
      this.tableInstance?.destroy?.();
    } catch {
      // ignore destroy errors during teardown
    }
  }

  private initTable(): void {
    if (this.tableInstance) {
      return;
    }

    const options = { ...(this.dtOptions || {}) } as Config;

    // Prefer the legacy jQuery + Bootstrap 4 integration already loaded by angular.json.
    // That path preserves the markup/classes the project used before removing angular-datatables.
    if (typeof $ !== 'undefined' && $.fn?.dataTable) {
      this.tableInstance = $(this.elementRef.nativeElement).DataTable(options);
    } else {
      throw new Error('DataTables jQuery runtime is not available. Verify angular.json scripts for DataTables and Bootstrap integration.');
    }

    this.resolveDtInstance(this.tableInstance);
  }
}

@NgModule({
  imports: [DatatableCompatDirective],
  exports: [DatatableCompatDirective],
})
export class DatatableCompatModule {}
